import * as React from "react";
import * as _ from "lodash";
import { AgentGroup } from "shared/model/AgentGroup";

const useDefaultAgentGroupInEnvironment = (props: IDefaultAgentGroupInEnvironment) => {
    const [firstAgentGroupInEnv, setFirstAgentGroupInEnv] = React.useState<string>();

    React.useEffect(() => {
        if (!_.isEmpty(props.agentGroups)) {
            const firstAgentGroup = props.agentGroups.find((agrp) => agrp.environment === props.environmentName)?.name;
            setFirstAgentGroupInEnv(firstAgentGroup);
        }
    }, [props.agentGroups]);

    return firstAgentGroupInEnv;
}

interface IDefaultAgentGroupInEnvironment {
    agentGroups: AgentGroup[];
    environmentName: string;
}

export default useDefaultAgentGroupInEnvironment;